<template>
    <div class="widget position--fixed" id="widget">
        <button-with-icon
            :icon="{
                component: () => import( /* webpackChunkName: 'IconSettings' */ '@/components/bundles/layout/images/icons/IconSettings' ),
                class: 'widget__main__image'
            }"
            class="widget__main display--flex background--green shadow--default"
            :action="{
                execute: true,
                function: toggleList
            }"
        />
        <transition name="fade" mode="out-in">
            <portal-target v-show="showList" name="widget" class="widget__list position--absolute background--white shadow--default" tag="ul" />
        </transition>
    </div>
</template>

<script>
// package
import { ref } from '@vue/composition-api';

// components
import { PortalTarget } from 'portal-vue';

// hooks
import handlerClickOutside from '@/hooks/handler-click-outside';

export default {
    components: {
        PortalTarget,
        ButtonWithIcon: () => import( /* webpackChunkName: 'ButtonWithIcon' */ '@/components/bundles/buttons/BaseButtonWithIcon' )
    },
    setup () {
        const showList = ref( false );

        /**
         * [method]
         * Click no widget, que irá dar toggle
         * a lista de opções de cada página.
         *
         * @since 1.0.0
         * @category Method
         * @autor Tiago Martinho
         *
        */
        const toggleList = () => {
            showList.value = !showList.value;
        };

        // validação do click fora do widget.
        handlerClickOutside({
            elementClass: 'widget__main',
            condition: showList,
            toggle: () => { showList.value = false; }
        });

        return { showList, toggleList };
    }
};
</script>

<style lang="scss">
    // =============================================================================
    // Style
    // =============================================================================
    .widget {
        @include transform-position( false, false, 60px, 30px );
        z-index: 3;
        &__main {
            @include position-grid( center, center );
            @include dimensions( 71px, 71px );
            @include rounded-corner( 50% );
            &__image {
                pointer-events: none;
            }
        }
        &__list {
            @include transform-position( false, false, 45px, 22px );
            width: max-content;
            padding: 10px 20px 10px 60px;
            z-index: -1;
            @include rounded-corner( 8px );
            &__option {
                display: flex;
                align-items: center;
                min-height: 35px;
                color: $color-red;
            }
        }
    }
</style>